import {
  WORKFLOW_STEP_VALUE_TYPE_DAYS,
  WORKFLOW_STEP_VALUE_TYPE_HOURS,
  WORKFLOW_WAIT_ERROR_MAX_DAYS,
  WORKFLOW_WAIT_ERROR_POSITION,
  WORKFLOW_WAIT_ERROR_REQUIRED_VALUE,
  WORKFLOW_WAIT_ERROR_REQUIRED_WAIT,
  WORKFLOW_WAIT_ERROR_WRONG_FORMAT
} from 'Constants'

import {
  DATA_RETENTION_LIMIT_THREE_MONTHS,
  DATA_RETENTION_LIMIT_YEAR,
  WORKFLOW_WAIT_TYPE_MODE_EMAIL,
  WORKFLOW_WAIT_TYPE_MODE_SMS
} from 'Constants/'
import { storeGet } from 'Helpers/localStorage'
import {
  regexIsIntegerNumberNotEmpty,
  STORE_KEY_ACCOUNT
} from 'mailup-react-helpers'
import uniqid from 'uniqid'

export const reorderWorkflowSteps = (startIndex, endIndex) => (prev) => {
  const result = Array.from(prev)
  const [removed] = result.splice(startIndex, 1)
  result.splice(endIndex, 0, removed)

  return result
}

export const deleteWorkflowStep = (droppableId) => (prev) => {
  return prev.filter((o) => o.id !== droppableId)
}

export const copyWorkflowStep = (fromItem, destinationIndex) => (prev) => {
  const result = Array.from(prev)
  result.splice(destinationIndex, 0, {
    ...fromItem,
    id: uniqid('workflow-step-')
  })

  return result
}

export const changeWorkflowStep =
  (droppableId, { actionType, payload }) =>
  (prev) => {
    switch (actionType) {
      case 'toggle_value_type':
        return prev.map((o) => ({
          ...o,
          ValueType:
            o.id === droppableId
              ? o.ValueType === WORKFLOW_STEP_VALUE_TYPE_DAYS
                ? WORKFLOW_STEP_VALUE_TYPE_HOURS
                : WORKFLOW_STEP_VALUE_TYPE_DAYS
              : o.ValueType,
          isDirty: o.id === droppableId ? true : o.isDirty,
          itemError:
            o.id === droppableId
              ? isValidField(
                  payload.value,
                  o.ValueType === WORKFLOW_STEP_VALUE_TYPE_DAYS
                    ? WORKFLOW_STEP_VALUE_TYPE_HOURS
                    : WORKFLOW_STEP_VALUE_TYPE_DAYS,
                  o.WaitType,
                  payload.mode,
                  true
                )
              : o.itemError
        }))

      case 'change_value':
        return prev.map((o) => ({
          ...o,
          Value: o.id === droppableId ? payload.value : o.Value,
          isDirty: o.id === droppableId ? true : o.isDirty,
          itemError:
            o.id === droppableId
              ? isValidField(
                  payload.value,
                  o.ValueType,
                  o.WaitType,
                  payload.mode,
                  true
                )
              : o.itemError
        }))

      case 'change_wait_type':
        return prev.map((o) => ({
          ...o,
          WaitType: o.id === droppableId ? payload.value : o.WaitType,
          isDirty: o.id === droppableId ? true : o.isDirty,
          itemError:
            o.id === droppableId
              ? isValidField(
                  o.Value,
                  o.ValueType,
                  payload.value,
                  payload.mode,
                  true
                )
              : o.itemError
        }))
      case 'edit_type':
        return prev.map((o) => ({
          ...o,
          IdMessage: o.id === droppableId ? payload.IdMessage : o.IdMessage,
          subject: o.id === droppableId ? payload.subject : o.subject
        }))
      /*
      case 'move_type':
        return prev.map((o) => ({
          ...o,
          // WaitType: o.id === droppableId ? payload.waitType : o.WaitType,
          itemError:
            o.id === droppableId
              ? isValidField(
                  o.Value,
                  o.ValueType,
                  o.WaitType,
                  payload.mode,
                  payload.isDirty
                )
              : o.itemError,
          isDirty: o.id === droppableId ? true : o.isDirty
        }))

      case 'change_mode':
        return prev.map((o) => ({
          ...o,
          isDirty: o.id === droppableId ? true : o.isDirty,
          WaitType:
            o.id === droppableId && o.mode && o.mode !== payload.mode
              ? -1
              : o.WaitType
        }))
        */
    }
  }

const isValidField = (value, valueType, waitType, mode, isDirty) => {
  if (isDirty && (waitType === undefined || waitType === -1)) {
    return WORKFLOW_WAIT_ERROR_REQUIRED_WAIT
  }
  if (value === '') {
    return WORKFLOW_WAIT_ERROR_REQUIRED_VALUE
  }
  if (mode === '') {
    return WORKFLOW_WAIT_ERROR_POSITION
  }
  if (!value.toString().match(regexIsIntegerNumberNotEmpty)) {
    return WORKFLOW_WAIT_ERROR_WRONG_FORMAT
  }
  if (value.toString().match(regexIsIntegerNumberNotEmpty)) {
    const { DataRetention } = storeGet(STORE_KEY_ACCOUNT)
    let daysLimit = 0
    const moltiplicatore = valueType === WORKFLOW_STEP_VALUE_TYPE_DAYS ? 1 : 24
    if (mode === WORKFLOW_WAIT_TYPE_MODE_EMAIL) {
      daysLimit =
        DataRetention < DATA_RETENTION_LIMIT_YEAR
          ? DataRetention * moltiplicatore
          : DATA_RETENTION_LIMIT_YEAR * moltiplicatore
    }
    if (mode === WORKFLOW_WAIT_TYPE_MODE_SMS) {
      daysLimit = DATA_RETENTION_LIMIT_THREE_MONTHS * moltiplicatore
    }
    return value > daysLimit ? WORKFLOW_WAIT_ERROR_MAX_DAYS : ''
  }
  return ''
}
